import { GridHeaderColumns, type GridHeaderColumnsProps } from './GridHeaderColumns';

export type TimesheetGridHeaderProps = GridHeaderColumnsProps;

/** Sticky `<thead>` of the timesheet grid. */
export function TimesheetGridHeader(props: TimesheetGridHeaderProps) {
  return (
    <thead className="sticky top-0 z-10 bg-background">
      <GridHeaderColumns {...props} />
    </thead>
  );
}
